import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {BlockForm, BlockTypeEnum, FormModel, FormState, FormType} from '../models';
import {FormModalComponent} from './shared/form-modal/form-modal.component';
import {Constants} from './common/constants';

@Component({
  selector: 'app-form-builder',
  templateUrl: './form-builder.component.html',
  styleUrls: ['./form-builder.component.scss']
})
export class FormBuilderComponent implements OnInit, OnChanges {
  @Input() formModel: FormModel;
  @Output() getForm = new EventEmitter<any>();

  constants: any = Constants;
  formType = FormType;
  formState = FormState;
  administratifBlockExist = false;
  constructor(public dialog: MatDialog) {}
  ngOnInit(): void {
    this.onGetForm();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.formModel?.currentValue?.id === 0) { // nouveau formulaire, on crée au moins un bloc
        this._createBlock();
    }
  }
  private _createBlock() {
    const newBlock = {
      nom: 'Titre du block',
      description: 'Description du block...',
      type: BlockTypeEnum.Public,
      fields: []
    };
    if (this.formModel.blocks) {
      this.formModel.blocks = [...this.formModel.blocks, newBlock];
    } else {
      this.formModel.blocks = [newBlock];
    }
  }
  onEmailSend(email) {
    this.formModel.email_generic = email;
  }
  addNewBlock() {
    this._createBlock();
  }
  editTitleForm(formModel): void {
    this.openFormDialog(formModel);
  }

  openFormDialog(item): void {
    const data = {...item};
    const dialogRef = this.dialog.open(FormModalComponent, {
      disableClose: true,
      width: '680px',
      data: {
        form: data,
        buttonText: {
          ok: 'Prendre en compte',
          cancel: 'Abandonner'
        },
      },
    });
    dialogRef.updatePosition({top: '100px'});
    dialogRef.afterClosed().subscribe(_data => {
      if (_data) {
        this.formModel = _data;
        this.onGetForm();
      }
    });
  }

  onRemoveBlock(blockIndex: number) {
    this.formModel.blocks.splice(blockIndex, 1);
    this.administratifBlockExist = this._checkForAdminBlock();
  }

  onCloseBlock(): void {
    this.administratifBlockExist = this._checkForAdminBlock();
  }

  onGetForm() {
    this.administratifBlockExist = this._checkForAdminBlock();
    this.getForm.emit(this.formModel);
  }

  private _checkForAdminBlock(): boolean {
    return  (!!this.formModel?.blocks.find(x => x.type === BlockTypeEnum.Administratif));
  }

  onMoveUpBlock(itemBlockObj: BlockForm) {
    this.moveBlock(itemBlockObj, -1);
  }

  onMoveDownBlock(itemBlockObj: BlockForm) {
    this.moveBlock(itemBlockObj, 1);
  }

  moveBlock(itemBlockObj: BlockForm, x: number) {
    // Calculer la nouvelle position
    const newPosition = itemBlockObj.position + x;

    const blocks = this.formModel?.blocks;
    const previousBlock = blocks.find(item => item.position === newPosition);
    let indexItemBlockObj = blocks.indexOf(itemBlockObj);
    let indexPreviousBlock = blocks.indexOf(previousBlock);

    // Échange positions
    if (previousBlock) {
      [itemBlockObj.position, previousBlock.position] = [previousBlock.position, itemBlockObj.position];
      this.swapIndexBlocks(blocks, indexItemBlockObj, indexPreviousBlock);
    }
  }

  swapIndexBlocks(array, index1, index2) {
    let temp = array[index1];
    [array[index1], array[index2]] = [array[index2], temp];
  }

}
